export const normalizeElementProperty = (rawData) => {
  return {
    uiType: rawData?.ui_type ?? '',
    text: rawData?.text ?? '',
    icon: rawData?.icon ?? ''
  }
}
